// Mirrors the Go backend's application/slip_dto.go and allocation_dto.go.
export type SlipStatus = "available" | "occupied" | "reserved" | "maintenance";
export type SlipType = "wet" | "dry" | "warehouse";
export type AllocationStatus = "pending" | "active" | "vacated";

export const SLIP_TYPE_LABELS: Record<SlipType, string> = {
  wet: "Wet",
  dry: "Dry",
  warehouse: "Warehouse",
};

// Summary-card / tab labels per storage bucket (plural phrasing).
export const STORAGE_BUCKET_LABELS: Record<SlipType, string> = {
  wet: "Wet Slips",
  dry: "Dry Storage",
  warehouse: "Warehouse",
};

export const SLIP_STATUS_LABELS: Record<SlipStatus, string> = {
  available: "Available",
  occupied: "Occupied",
  reserved: "Reserved",
  maintenance: "Out of Service",
};

export interface Slip {
  id: string;
  slip_number: string; // e.g., "A-12"
  type: SlipType;
  max_length_ft: number;
  status: SlipStatus;
  current_boat_id?: string | null;
  current_boat_name?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface StorageSummaryBucket {
  type: SlipType;
  total: number;
  occupied: number;
  available: number;
  reserved: number;
}

export interface StorageSummary {
  buckets: StorageSummaryBucket[];
}

export interface StorageAllocation {
  id: string;
  boat_id: string;
  slip_id?: string | null;
  slip_number: string;
  slip_type: SlipType;
  status: AllocationStatus;
  monthly_rate?: number | null;
  customer_id?: string | null;
  customer_name?: string;
  boat_make?: string;
  boat_model?: string;
  created_at: string;
  updated_at: string;
  vacated_at?: string | null;
}

// Write payloads for slip create/update.
export interface SlipWriteBody {
  id?: string // client-generated for offline create replay idempotency
  slip_number: string;
  type: SlipType;
  max_length_ft: number;
  status?: SlipStatus;
}
